import get from 'lodash/get';
import includes from 'lodash/includes';

import { graphQLEdClient } from '../../graphQLClients';

import { UpdateItemGqlQuery } from '../../../../../types';

import { generateUuid } from '../../../../../utils/generateUuid';
import { getQueryName } from '../../../../../utils/getQueryName';
import { productionConsole } from '../../../../../utils/productionConsole';
import { errorMessageStatusOrErrorsIsIncorrect } from '../../reactQueryConstants';

interface UpdateItemProps<UpdateItemInput> {
  action: string;
  query: UpdateItemGqlQuery;
  queryInput: UpdateItemInput;
}

const successQueryStatuses = ['updated', 'success'];

export function updateEdItem<UpdateItemInput, UpdateItemResponse>({
  action,
  query,
  queryInput
}: UpdateItemProps<UpdateItemInput>) {
  const { rawName, name } = getQueryName(query, 'mutation');

  productionConsole(
    'log',
    'updateEdItem',
    { action, queryInput },
    rawName,
    JSON.stringify(queryInput)
  );

  const requestId = generateUuid();

  graphQLEdClient.addQueryParams(name, requestId);

  return new Promise<UpdateItemResponse>((resolve, reject) => {
    graphQLEdClient
      .request<UpdateItemResponse, UpdateItemInput>(query, queryInput, {
        requestId
      })
      .then((response) => {
        if (includes(successQueryStatuses, get(response, `${action}.status`))) {
          return resolve(response);
        }

        const errors = get(response, `${action}.errors`);

        reject(errors ? errors : errorMessageStatusOrErrorsIsIncorrect);
      })
      .catch((reason) => reject(reason));
  });
}
